import { IssueTimelineDto } from '@issuemanager/api-client';
import { WrappedTypography } from '@issuemanager/apps/client/components';
import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ActionTimelineEventDetails } from './action-timeline-event-details';
import IssueTimelineChangesContainer from './issue-timeline-changes-container';

interface IssueTimelineEditedEventsProps {
  events: IssueTimelineDto[];
}

export function EditedActionTimelineEvents({
  events,
}: IssueTimelineEditedEventsProps): React.JSX.Element {
  const { t } = useTranslation('common');

  const groupedEvents = useMemo(
    () =>
      events.reduce((acc, event) => {
        const actionTitle = event.bodyData.parameters.actionTitle?.value || '';

        if (!actionTitle) return acc;

        if (!acc[actionTitle]) {
          acc[actionTitle] = [];
        }

        acc[actionTitle].push(event);
        return acc;
      }, {} as Record<string, IssueTimelineDto[]>),
    [events],
  );

  return (
    <Box>
      {Object.entries(groupedEvents).map(([actionTitle, actionEvents]) => (
        <Box
          key={actionTitle}
          data-testid='action-edited-timeline-event'
          data-title={actionTitle}
        >
          <WrappedTypography data-testid='action-edited-timeline-event-title'>
            <Trans
              t={t}
              i18nKey='issueTimeline.actionEdited'
              values={{ title: actionTitle }}
            />
          </WrappedTypography>

          <IssueTimelineChangesContainer data-testid='issue-actions-timeline-events'>
            {actionEvents.map((event) => (
              <ActionTimelineEventDetails key={event.id} event={event} />
            ))}
          </IssueTimelineChangesContainer>
        </Box>
      ))}
    </Box>
  );
}
